<template>
  <div class="animated fadeIn demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <div>历史查询SIM卡号</div>
        <Button style="margin-top: 3px;" size="small" type="primary" @click="onClearHistorySimNums">清空历史</Button>
        <Button style="margin-top: 3px; display:block;" size="small" :type="item.recvNew" v-for="item in historySimNums" @click="onHistoryClick(item)">{{item.simNum}}</Button>
      </div>
      <div slot="right" class="demo-split-pane">
        <Row style="margin-bottom: 3px;">
          <Select
            size="small"
            placeholder="选择SIM卡号"
            v-model="simNum"
            filterable
            remote
            :remote-method="searchSim"
            :loading="searchSimLoading"
            style="width: 200px; margin-right: 3px;"
            clearable>
            <Option v-for="(option, index) in searchSimList" placeholder="输入SIM卡号" :value="option.simNum" :key="index">{{option.simNum}}</Option>
          </Select>
          <Button type="primary" size="small" style="margin-right: 10px;" @click="onSearchClick">查询</Button>
          <Button type="primary" size="small" style="margin-right: 10px;" @click="onBatchSendRMDeviceSMS">批量发送锐明设置省平台短信</Button>
          <Button type="primary" size="small" style="margin-right: 10px;" @click="batchSetMessagesModal = true">批量发送平台短信</Button>
          <Button type="primary" size="small" style="margin-right: 10px;" @click="terminalnumBatchSendMessagesModal = true">按主机号批量发送短信</Button>
        </Row>
        <Row v-if="simInfo && simNum" style="margin-top: 10px; margin-bottom: 10px;">
          <label style="margin-right: 30px;">13位SIM卡号：{{simInfo.content[0].simNum}}</label>
          <label style="margin-right: 30px;">11位SIM卡号：{{simInfo.content[0].simShortNum}}</label>
          <label style="margin-right: 30px;">设备主机号：{{simInfo.content[0].positioningDeviceInfoId != null ? simInfo.content[0].positioningDeviceInfo.terminalNum :'未绑定设备'}}</label>
          <label v-if="simInfo.content[0].operation == 1">中国移动</label>
          <label v-if="simInfo.content[0].operation == 2">中国联通</label>
          <label v-if="simInfo.content[0].operation == 3">中国电信</label>
          <label v-if="simInfo.content[0].operation == 4">珠海移动专网</label>
          <label v-if="simInfo.content[0].operation == 5">中国移动-东莞中智</label>
          <label v-if="simInfo.content[0].operation == 6">中国移动-佛山交协</label>
          <label v-if="simInfo.content[0].operation == 7">中国电信-中山邦悦</label>
          <label v-if="simInfo.content[0].operation == 8">中国移动-河北九宸</label>
          <label v-if="simInfo.content[0].operation == 9">中国移动-中山邦悦</label>
          <label v-if="simInfo.content[0].operation == 10">中国联通-中山邦悦</label>
          <label v-if="simInfo.content[0].operation == 11">中国移动-深圳晓聪</label>
          <label style="margin-left: 30px;color: red">{{simInfo.content[0].remark}}</label>
        </Row>

        <Row style="">
          <div style="width: 100%;">
          <Scroll :height="scrollHeight" ref="shortMessageScroll">
            <div style="position:relative;">
              <div id="smscontent" class="message-history">
                <div v-for="sms in shortMessageContent">
                  <div v-if="sms.direction === 1">
                    <div class="message-receive">
                      <div class="message-time">{{new Date(sms.createDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</div>
                      <div class="message-info">
                        <div class="user-info">
                          <img class="user-avatar" src="/smshead.jpg"/>
                        </div>
                        <div class="message-content-box">
                          <div class="arrow"></div>
                          <div class="message-content">{{sms.content}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="message-reply">
                      <div class="message-time">【{{sms.user==null?'':sms.user.realName==null?sms.user.nickName:sms.user.realName}}】{{new Date(sms.createDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</div>
                      <div class="message-info">
                        <div class="user-info">
                          <img class="user-avatar" src="/smshead.jpg"/>
                        </div>
                        <div class="message-content-box">
                          <div class="arrow"></div>
                          <div class="message-content">{{sms.content}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="list_loadding">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
              </div>
            </div>
          </Scroll>
          </div>
        </Row>
        <Row style="margin-top: 10px;">
          <Input v-model="sendContent" type="textarea" placeholder="请输入短信内容" clearable></Input>
        </Row>
        <Row style="margin-top: 10px;" type="flex" justify="end">
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="clearSendContent">清空</Button>
          </Col>
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="onSendCKBSJClick">查询参数</Button>
          </Col>
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="onSetupParamsClikc">设置参数</Button>
          </Col>
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="onSendCKVERClick">查询版本</Button>
          </Col>
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="onInitClick">初始化设备</Button>
          </Col>
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="onSetMaxSpeedClick">设置限速报警</Button>
          </Col>
          <Col style="margin-right: 10px;">
            <Button type="primary" @click="onSendShortMessageClick">发送</Button>
          </Col>

          <Col style="margin-right: 10px;">
          <Button @click="Open" type="primary">Open测试</Button>
          </Col>

        </Row>

        <Drawer title="短信模板" :closable="false" v-model="model" width="20">
          <Tree :data="treeData" expand-node :render="renderContent"></Tree>
        </Drawer>

        <setup-bsj-params-sms-modal v-model="setupBsjParamsSmsModal"
                                    :initValue="setupBsjParamsSmsSimNum"></setup-bsj-params-sms-modal>
        <init-bsj-sms-modal v-model="initBsjSmsModal"
                                    :initValue="initBsjSmsSimNum"></init-bsj-sms-modal>
        <bsj-set-max-speed-sms-modal v-model="bsjSetMaxSpeedSmsModal"
                                     :initValue="bsjSetMaxSpeedSmsId"></bsj-set-max-speed-sms-modal>
        <batch-set-messages-modal v-model="batchSetMessagesModal" @on-success="onBatchSetMessages"></batch-set-messages-modal>
        <terminalnum-batch-send-messages-modal v-model="terminalnumBatchSendMessagesModal" @on-success="onBatchSetMessages"></terminalnum-batch-send-messages-modal>

        <setup-hik-gghypt-sms-modal v-model="setupHikGghyptSmsModal" :initValue="setupHikGghyptSmsId"></setup-hik-gghypt-sms-modal>
        <setup-hik-dlysjg-sms-modal v-model="setupHikDlysjgSmsModal" :initValue="setupHikDlysjgSmsId"></setup-hik-dlysjg-sms-modal>
        <setup-hik-dayabay-sms-modal v-model="setupHikDayabaySmsModal" :initValue="setupHikDayabaySmsId"></setup-hik-dayabay-sms-modal>
        <setup-hik-ip-port-sms-modal v-model="setupHikIpPortSmsModal" :initValue="setupHikIpPortSmsId"></setup-hik-ip-port-sms-modal>
        <setup-hik-serial-number-sms-modal v-model="setupHikSerialNumberSmsModal" :initValue="setupHikSerialNumberSmsId"></setup-hik-serial-number-sms-modal>
        <setup-hik-enabled-agreement-sms-modal v-model="setupHikEnabledAgreementSmsModal" :initValue="setupHikEnabledAgreementSmsId"></setup-hik-enabled-agreement-sms-modal>
        <setup-hik-protocol-version-sms-modal v-model="setupHikProtocolVersionSmsModal" :initValue="setupHikProtocolVersionSmsId"></setup-hik-protocol-version-sms-modal>
        <setup-hik-trigger-alarm-sms-modal v-model="setupHikTriggerAlarmSmsModal" :initValue="setupHikTriggerAlarmSmsId"></setup-hik-trigger-alarm-sms-modal>

        <setup-rm-qhtc-sms-modal v-model="setupRmQhtcSmsModal" :initValue="setupRmQhtcSmsId"></setup-rm-qhtc-sms-modal>
        <setup-rm-wakeup-sms-modal v-model="setupRmWakeupSmsModal" :initValue="setupRmWakeupSmsId"></setup-rm-wakeup-sms-modal>
        <setup-rm-snyw-sms-modal v-model="setupRmSnywSmsModal" :initValue="setupRmSnywSmsId"></setup-rm-snyw-sms-modal>
        <setup-rm-sn9s-sms-modal v-model="setupRmSn9sSmsModal" :initValue="setupRmSn9sSmsId"></setup-rm-sn9s-sms-modal>
        <setup-rm-gghypt-sms-modal v-model="setupRmGghyptSmsModal" :initValue="setupRmGghyptSmsId"></setup-rm-gghypt-sms-modal>
        <setup-rm-dlysjg-sms-modal v-model="setupRmDlysjgSmsModal" :initValue="setupRmDlysjgSmsId"></setup-rm-dlysjg-sms-modal>
        <setup-rm-dayabay-sms-modal v-model="setupRmDayabaySmsModal" :initValue="setupRmDayabaySmsId"></setup-rm-dayabay-sms-modal>
        <setup-rm-ip-sms-modal v-model="setupRmIpSmsModal" :initValue="setupRmIpSmsId"></setup-rm-ip-sms-modal>
        <setup-rm-stif-sms-modal v-model="setupRmStifSmsModal" :initValue="setupRmStifSmsId"></setup-rm-stif-sms-modal>
        <setup-rm-number-sms-modal v-model="setupRmNumberSmsModal" :initValue="setupRmNumberSmsId"></setup-rm-number-sms-modal>
      </div>
    </Split>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import config from '@/config'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import Cookies from 'js-cookie'
import jcicp from '@/proto/jcicp.js'
import { jcicpEncode, jcicpDecode } from '@/libs/jcicputil.js'
import SetupBsjParamsSmsModal from '@/view/ddm/components/setup-bsj-params-sms-modal'
import InitBsjSmsModal from '@/view/ddm/components/init-bsj-sms-modal'
import BsjSetMaxSpeedSmsModal from '@/view/ddm/components/bsj-set-max-speed-sms-modal'
import BatchSetMessagesModal from '@/view/ddm/components/batch-set-messages-modal'
import TerminalnumBatchSendMessagesModal from '@/view/ddm/components/terminalnum-batch-send-messages-modal'

import SetupHikGghyptSmsModal from '@/view/ddm/components/setup-hik-gghypt-sms-modal'
import SetupHikDlysjgSmsModal from '@/view/ddm/components/setup-hik-dlysjg-sms-modal'
import SetupHikDayabaySmsModal from '@/view/ddm/components/setup-hik-dayabay-sms-modal'
import SetupHikIpPortSmsModal from '@/view/ddm/components/setup-hik-ip-port-sms-modal'
import SetupHikSerialNumberSmsModal from '@/view/ddm/components/setup-hik-serial-number-sms-modal'
import SetupHikEnabledAgreementSmsModal from '@/view/ddm/components/setup-hik-enabled-agreement-sms-modal'
import SetupHikProtocolVersionSmsModal from '@/view/ddm/components/setup-hik-protocol-version-sms-modal'
import SetupHikTriggerAlarmSmsModal from '@/view/ddm/components/setup-hik-trigger-alarm-sms-modal'

import SetupRmQhtcSmsModal from '@/view/ddm/components/setup-rm-qhtc-sms-modal'
import SetupRmWakeupSmsModal from '@/view/ddm/components/setup-rm-wakeup-sms-modal'
import SetupRmSnywSmsModal from '@/view/ddm/components/setup-rm-snyw-sms-modal'
import SetupRmSn9sSmsModal from '@/view/ddm/components/setup-rm-sn9s-sms-modal'
import SetupRmGghyptSmsModal from '@/view/ddm/components/setup-rm-gghypt-sms-modal'
import SetupRmDlysjgSmsModal from '@/view/ddm/components/setup-rm-dlysjg-sms-modal'
import SetupRmDayabaySmsModal from '@/view/ddm/components/setup-rm-dayabay-sms-modal'
import SetupRmIpSmsModal from '@/view/ddm/components/setup-rm-ip-sms-modal'
import SetupRmStifSmsModal from '@/view/ddm/components/setup-rm-stif-sms-modal'
import SetupRmNumberSmsModal from '@/view/ddm/components/setup-rm-number-sms-modal'

// import Cookies from 'js-cookie';
// //set
// Cookies.set('CardNo', cardNo, {expires: 7});//cookie保存7天
// //get
// let CardNo = Cookies.get("CardNo");
// //remove
// Cookies.remove('HMcart');
function stringArrayRemove (array, str) {
  console.log(str)
  let index = array.indexOf(str)
  if (index > -1) {
    array.splice(index, 1)
    console.log('移除' + str)
  }
}

export default {
  name: 'shortmessagesdebug',
  components: {
    SetupBsjParamsSmsModal,
    InitBsjSmsModal,
    BsjSetMaxSpeedSmsModal,
    BatchSetMessagesModal,
    TerminalnumBatchSendMessagesModal,

    SetupHikGghyptSmsModal,
    SetupHikDlysjgSmsModal,
    SetupHikDayabaySmsModal,
    SetupHikIpPortSmsModal,
    SetupHikSerialNumberSmsModal,
    SetupHikEnabledAgreementSmsModal,
    SetupHikProtocolVersionSmsModal,
    SetupHikTriggerAlarmSmsModal,

    SetupRmQhtcSmsModal,
    SetupRmWakeupSmsModal,
    SetupRmSnywSmsModal,
    SetupRmSn9sSmsModal,
    SetupRmGghyptSmsModal,
    SetupRmDlysjgSmsModal,
    SetupRmDayabaySmsModal,
    SetupRmIpSmsModal,
    SetupRmStifSmsModal,
    SetupRmNumberSmsModal
  },
  data () {
    return {

      split1: '180px',

      historySimNums: [],

      // 批量发送短信
      batchSetMessagesModal: false,

      // 批量发送海康ip卡号短信
      terminalnumBatchSendMessagesModal: false,

      // BSJ设置最高限速报警
      bsjSetMaxSpeedSmsModal: false,
      bsjSetMaxSpeedSmsId: null,

      // 设置BSJ终端参数
      setupBsjParamsSmsModal: false,
      setupBsjParamsSmsSimNum: null,

      // 初始化BSJ终端
      initBsjSmsModal: false,
      initBsjSmsSimNum: null,

      searchSimLoading: false,
      searchSimList: [],

      // 海康设置货运平台
      setupHikGghyptSmsModal: false,
      setupHikGghyptSmsId: null,

      // 海康设置“两客一危一重”车辆智能监管系统
      setupHikDlysjgSmsModal: false,
      setupHikDlysjgSmsId: null,

      // 海康设置“大亚湾”
      setupHikDayabaySmsModal: false,
      setupHikDayabaySmsId: null,

      // 海康设置IP/域名
      setupHikIpPortSmsModal: false,
      setupHikIpPortSmsId: null,

      // 海康设置客管序列号与终端ID
      setupHikSerialNumberSmsModal: false,
      setupHikSerialNumberSmsId: null,

      // 海康设置平台IP和端口
      setupHikEnabledAgreementSmsModal: false,
      setupHikEnabledAgreementSmsId: null,

      // 海康设置平台协议版本
      setupHikProtocolVersionSmsModal: false,
      setupHikProtocolVersionSmsSmsId: null,

      // 海康认为触发报警
      setupHikTriggerAlarmSmsModal: false,
      setupHikTriggerAlarmSmsId: null,

      // 锐明查询设备加密芯片号
      setupRmQhtcSmsModal: false,
      setupRmQhtcSmsId: null,

      // 锐明唤醒设备
      setupRmWakeupSmsModal: false,
      setupRmWakeupSmsId: null,

      // 锐明设置N9运维网络
      setupRmSnywSmsModal: false,
      setupRmSnywSmsId: null,

      // 锐明设置N9M服务器
      setupRmSn9sSmsModal: false,
      setupRmSn9sSmsId: null,

      // 锐明设置货运平台
      setupRmGghyptSmsModal: false,
      setupRmGghyptSmsId: null,

      // 锐明设置"两客一危"平台
      setupRmDlysjgSmsModal: false,
      setupRmDlysjgSmsId: null,

      // 锐明设置"大亚湾"平台
      setupRmDayabaySmsModal: false,
      setupRmDayabaySmsId: null,

      // 锐明设置通道
      setupRmIpSmsModal: false,
      setupRmIpSmsId: null,

      // 锐明设置终端信息
      setupRmStifSmsModal: false,
      setupRmStifSmsId: null,

      // 锐明设置设备ID(终端ID)
      setupRmNumberSmsModal: false,
      setupRmNumberSmsId: null,

      scrollHeight: 450,
      lodding: false,
      list_loadding: false,

      shortMessageContent: [],
      sendContent: '',
      simNum: '',
      simInfo: null,
      sort: { name: 'createDatetime', asc: false },
      websock: null,

      model: false,

      treeData: [
        {
          title: '博实结',
          expand: true,
          children: [// index：0
            {
              title: '查询参数'
            },
            {
              title: '设置参数'
            },
            {
              title: '查询版本'
            },
            {
              title: '初始化设备'
            },
            {
              title: '设置限速报警'
            }
          ]
        },
        {
          title: '海康',
          expand: true,
          children: [// index：6
            {
              title: '重启'
            },
            {
              title: '设置货运平台'
            },
            {
              title: '设置"两客一危"平台'
            },
            {
              title: '设置"大亚湾"平台'
            },
            {
              title: '设置IP/域名'
            },
            {
              title: '设置客管序列号与终端ID'
            },
            {
              title: '设置平台协议版本'
            },
            {
              title: '设置平台协议'
            },
            {
              title: '触发报警行为'
            }
          ]
        },
        {
          title: '锐明',
          expand: true,
          children: [// index：16
            {
              title: '查询设备加密芯片号'
            },
            {
              title: '唤醒设备'
            },
            {
              title: '设置N9运维网络'
            },
            {
              title: '设置N9M服务器'
            },
            {
              title: '设置货运平台'
            },
            {
              title: '设置"两客一危"平台'
            },
            {
              title: '设置"大亚湾"平台'
            },
            {
              title: '设置IP/域名'
            },
            {
              title: '设置终端信息'
            },
            {
              title: '设置设备ID(终端ID)'
            }
          ]
        },
        {
          title: '中天安驰',
          expand: true,
          children: [// index：27
            //     {
            //       title: '写卡',
            //     },
            //     {
            //       title: '设置车辆参数',
            //     },
            //     {
            //       title: '设置速度报警',
            //     },
            //     {
            //       title: '磁盘格式化',
            //     },
            //     {
            //       title: '设置里程',
            //     },
            //     {
            //       title: '重启控制',
            //     },
            //     {
            //       title: 'ADAS报警',
            //     },
            //     {
            //       title: 'DSM报警',
            //     },
            //     {
            //       title: '报警使能',
            //     },
          ]
        },
        {
          title: '通用',
          expand: true,
          children: [// 27
            // {
            //   title: '采集车牌号',
            // },
            // {
            //   title: '采集驾驶员身份证',
            // },
            // {
            //   title: '采集设备信息',
            // },
          ]
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'SimInfoServ_SearchByName',
      'ShortMessageServ_GetPage',
      'ShortMessageServ_Send'
    ]),
    onBatchSetMessages (e) {
      console.log(e)
      e.forEach(item => {
        if (!this.existHistorySimNum(item)) {
          this.historySimNums = [{ simNum: item, recvNew: false }].concat(this.historySimNums)
          Cookies.set('historySimNums', this.historySimNums, { expires: 7 })
        }
      })
    },
    onClearHistorySimNums () {
      Cookies.remove('historySimNums')
      this.historySimNums = []
    },
    onHistoryClick (item) {
      let simNum = item.simNum
      item.recvNew = 'default'
      console.log(simNum)
      this.simNum = simNum
      this.onSearchClick()
    },
    onSetupParamsClikc () {
      if (!this.simNum || this.simNum === '') {
        this.$Message.error('请选择SIM卡号')
        return
      }
      this.setupBsjParamsSmsSimNum = this.simNum
      this.setupBsjParamsSmsModal = true
    },
    existHistorySimNum (simNum) {
      let index = -1
      for (var i = 0; i < this.historySimNums.length; i++) {
        if (this.historySimNums[i].simNum === simNum) {
          return true
        }
      }
      return false
    },
    removeHistorySimNum (simNum) {
      let index = -1
      for (var i = 0; i < this.historySimNums.length; i++) {
        if (this.historySimNums[i].simNum === simNum) {
          index = i
          break
        }
      }
      if (index !== -1) {
        this.historySimNums.splice(index, 1)
      }
    },
    onBatchSendRMDeviceSMS () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>注意：确认批量发送锐明设置省平台短信</p>',
        onOk: () => {
          store.dispatch('ShortMessageServ_BatchSendRMDeviceSMS', { params: null }).then(() => {
            this.$Message.success('开始设置')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    onSearchClick () {
      if (!this.simNum || this.simNum === '') {
        this.$Message.error('请选择SIM卡号')
        return
      }
      if (!this.existHistorySimNum(this.simNum)) {
        this.historySimNums = [{ simNum: this.simNum, recvNew: false }].concat(this.historySimNums)
        Cookies.set('historySimNums', this.historySimNums, { expires: 7 })
      }
      this.refreshPage(this.pageFilter)
    },
    searchSim (input) {
      this.searchSimLoading = true
      if (!input || input.length <= 0) {
        this.searchSimList = []
        this.searchSimLoading = false
      } else {
        store.dispatch('SimInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSimList = store.getters.get_SimInfo_SearchByNameResult ? store.getters.get_SimInfo_SearchByNameResult : []
          this.searchSimLoading = false
        }).catch(err => {
          console.log(err)
          this.searchSimLoading = false
        })
      }
    },
    threadPoxi () { // 实际调用的方法
      // 参数
      const agentData = 'mymessage'
      // 若是ws开启状态
      if (this.websock.readyState === this.websock.OPEN) {
        this.websocketsend(agentData)
      }
      // 若是 正在开启状态，则等待300毫秒
      else if (this.websock.readyState === this.websock.CONNECTING) {
        let that = this// 保存当前对象this
        setTimeout(function () {
          that.websocketsend(agentData)
        }, 300)
      }
      // 若未开启 ，则等待500毫秒
      else {
        this.initWebSocket()
        let that = this// 保存当前对象this
        setTimeout(function () {
          that.websocketsend(agentData)
        }, 500)
      }
    },
    initWebSocket () { // 初始化weosocket
      // ws地址
      const wsuri = config.baseUrl.pro_ws + '/websocket'
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onclose = this.websocketclose
      this.websock.binaryType = 'arraybuffer'
    },
    websocketonopen (event) {
      console.log('Websocket连接打开')
    },
    onShortMessageDataFrame (result, websock) {
      console.log('onShortMessageDataFrame')
      let frame = result.frame
      console.log(frame)
      let newItem = {
        simNum: frame.simNum,
        content: frame.smsContent,
        direction: frame.direction,
        createDatetime: 0
      }
      console.log(newItem)
      this.historySimNums.forEach(item => {
        if (item.simNum === newItem.simNum && newItem.direction === 1) {
          console.log('收到新消息')
          item.recvNew = 'warning'
        } else {
          item.recvNew = 'default'
        }
      })
      Cookies.set('historySimNums', this.historySimNums, { expires: 7 })
      if (this.simNum === newItem.simNum) {
        this.shortMessageContent.unshift(newItem)
      }
    },
    websocketonmessage (e) { // 数据接收
      console.log('接收到数据')
      let result = jcicpDecode(e.data)
      console.log(result)
      if (result.frameTypeName === 'ShortMessageDataFrame') {
        console.log('result.name')
        this.onShortMessageDataFrame(result, this.websock)
      }
    },
    websocketsend () { // 数据发送
      this.websock.send(agentData)
    },
    websocketclose (e) { // 关闭
      console.log('connection closed (' + e.code + ')')
    },
    clearSendContent () {
      this.sendContent = ''
    },
    onSendShortMessageClick () {
      this.sendSMS(this.sendContent)
    },
    onSetMaxSpeedClick () {
      this.bsjSetMaxSpeedSmsModal = true
      this.bsjSetMaxSpeedSmsId = this.simNum
    },
    onSendCKVERClick () {
      this.sendSMS('<CKVER>')
    },
    onSendCKBSJClick () {
      this.sendSMS('<CKBSJ>')
    },
    onInitClick () {
      if (!this.simNum || this.simNum === '') {
        this.$Message.error('请选择SIM卡号')
        return
      }
      this.initBsjSmsSimNum = this.simNum
      this.initBsjSmsModal = true
    },
    sendSMS (content) {
      if (!this.simNum || this.simNum === '') {
        this.$Message.error('请选择SIM卡号')
        return
      }
      store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    subscribe (simNums) {
      let subscribeSmsFrameBuilder = jcicp.lookup('SubscribeSmsFrame')
      let subscribeSmsFrame = subscribeSmsFrameBuilder.create({
        selectAll: false,
        simNums: simNums
      })
      let buffer = subscribeSmsFrameBuilder.encode(subscribeSmsFrame).finish()
      let data = jcicpEncode('SubscribeSmsFrame', buffer)
      this.websock.send(data)
    },
    setPage (page) {
      if (this.simNum && this.simNum != '') {
        store.dispatch('SimInfoServ_GetPage', {
          params: null,
          urlparams: {
            q: genQueryParam('simNum', 'EQ', this.simNum)
          }
        }).then(() => {
          this.simInfo = store.getters.get_SimInfo_GetPageResult
          console.log('SimServ_GetAll')
          console.log(this.simInfo)


      this.pageIndex = page
      this.list_loadding = true

      let queryParam = null
      let sortParam = null

      if (this.simNum !== null && this.simNum !== undefined && this.simNum.trim() !== '') {
        this.simNum = this.simNum.trim()
        queryParam = genQueryParam('simNum', 'EQ', this.simNum)
      }

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      store.dispatch('ShortMessageServ_GetPage', {
        params: null,
        urlparams: {
          p: page,
          q: queryParam,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.list_loadding = false
        console.log(this.content)
        this.shortMessageContent = this.content
        if (this.simNum !== null && this.simNum !== undefined && this.simNum !== '') {
          this.subscribe([this.simNum])
        }
      }).catch(err => {
        this.list_loadding = false
        this.$Message.error(err)
      })

        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    },
    Open () {
      if (!this.simNum || this.simNum === '') {
        this.$Message.error('请选择SIM卡号')
        return
      }
      this.model = true
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          color: '#666',
          cursor: 'pointer',
          fontSize: '20px'
        },
        domProps: {
          className: 'btn'
        },
        on: {
          click: (e) => {
            // 用nodeKey调用方法
            console.log(data.nodeKey)
            console.log(this._initValue)// jt808,id

            /* 博实结 */
            // 查询参数
            if (data.nodeKey == 1) {
              this.sendSMS('<CKBSJ>')
            }
            // 设置参数
            if (data.nodeKey == 2) {
              if (!this.simNum || this.simNum === '') {
                this.$Message.error('请选择SIM卡号')
                return
              }
              this.setupBsjParamsSmsSimNum = this.simNum
              this.setupBsjParamsSmsModal = true
            }
            // 查询版本
            if (data.nodeKey == 3) {
              this.sendSMS('<CKVER>')
            }
            // 初始化设备
            if (data.nodeKey == 4) {
              if (!this.simNum || this.simNum === '') {
                this.$Message.error('请选择SIM卡号')
                return
              }
              this.initBsjSmsSimNum = this.simNum
              this.initBsjSmsModal = true
            }
            // 设置限速报警
            if (data.nodeKey == 5) {
              this.bsjSetMaxSpeedSmsModal = true
              this.bsjSetMaxSpeedSmsId = this.simNum
            }

            /* 海康 */
            // 重启
            if (data.nodeKey == 7) {
              this.sendSMS('RESTART;A')
            }
            // 设置货运平台
            if (data.nodeKey == 8) {
              // 共三条短信，1、设置IP或域名。2、设置卡号。3、设置通道使能及协议

              this.setupHikGghyptSmsModal = true
              this.setupHikGghyptSmsId = this.simNum
            }
            // 设置"两客一危"平台
            if (data.nodeKey == 9) {
              // 共三条短信，1、设置IP或域名。2、设置卡号。3、设置通道使能及协议

              this.setupHikDlysjgSmsModal = true
              this.setupHikDlysjgSmsId = this.simNum
            }
            // 设置"大亚湾"平台
            if (data.nodeKey == 10) {
              // 新指令，一条短信

              this.setupHikDayabaySmsModal = true
              this.setupHikDayabaySmsId = this.simNum
            }
            // 设置IP/域名
            if (data.nodeKey == 11) {
              this.setupHikIpPortSmsModal = true
              this.setupHikIpPortSmsId = this.simNum
              // //                     通道
              // this.sendSMS('TEL_ID:'+ 2 +',' + 0 + store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].terminalNum + ',' + this.simNum.substring(6) + ';A')
            }
            // 设置客管序列号与终端ID
            if (data.nodeKey == 12) {
              this.setupHikSerialNumberSmsModal = true
              this.setupHikSerialNumberSmsId = this.simNum
              // //                     通道
              // this.sendSMS('TEL_ID:'+ 2 +',' + 0 + store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].terminalNum + ',' + this.simNum.substring(6) + ';A')
            }
            // 设置平台协议版本
            if (data.nodeKey == 13) {
              this.setupHikProtocolVersionSmsModal = true
              this.setupHikProtocolVersionSmsId = this.simNum
            }
            // 设置平台协议
            if (data.nodeKey == 14) {
              this.setupHikEnabledAgreementSmsModal = true
              this.setupHikEnabledAgreementSmsId = this.simNum
              // //                    通道    使能  报警使能  协议
              // this.sendSMS('PROTO:'+ 2 +','+ 2 +','+ 2 +','+ 2 +';A')
            }
            // 触发报警行为
            if (data.nodeKey == 15) {
              this.setupHikTriggerAlarmSmsModal = true
              this.setupHikTriggerAlarmSmsId = this.simNum
            }

            /* 锐明 */
            // 查询设备加密芯片号
            if (data.nodeKey == 17) {
              this.setupRmQhtcSmsModal = true
              this.setupRmQhtcSmsId = this.simNum
            }
            // 锐明唤醒设备
            if (data.nodeKey == 18) {
              this.setupRmWakeupSmsModal = true
              this.setupRmWakeupSmsId = this.simNum
            }
            // 设置锐明N9运维网络
            if (data.nodeKey == 19) {
              this.setupRmSnywSmsModal = true
              this.setupRmSnywSmsId = this.simNum
            }
            // 锐明设置N9M服务器
            if (data.nodeKey == 20) {
              this.setupRmSn9sSmsModal = true
              this.setupRmSn9sSmsId = this.simNum
            }
            // 锐明设置设置货运平台
            if (data.nodeKey == 21) {
              this.setupRmGghyptSmsModal = true
              this.setupRmGghyptSmsId = this.simNum
            }
            // 锐明设置"两客一危"平台
            if (data.nodeKey == 22) {
              this.setupRmDlysjgSmsModal = true
              this.setupRmDlysjgSmsId = this.simNum
            }
            // 锐明设置"大亚湾"平台
            if (data.nodeKey == 23) {
              this.setupRmDayabaySmsModal = true
              this.setupRmDayabaySmsId = this.simNum
            }
            // 设置IP/域名
            if (data.nodeKey == 24) {
              this.setupRmIpSmsModal = true
              this.setupRmIpSmsId = this.simNum
            }
            // 锐明设置终端信息
            if (data.nodeKey == 25) {
              this.setupRmStifSmsModal = true
              this.setupRmStifSmsId = this.simNum
            }
            // 锐明设置设备ID(终端ID)
            if (data.nodeKey == 26) {
              this.setupRmNumberSmsModal = true
              this.setupRmNumberSmsId = this.simNum
            }

            /* 中天安驰 */

            /* 通用 */
          }
        }
      }, data.title)
    }

  },
  computed: {
    totalElements () {
      if (store.getters.get_ShortMessage_GetPageResult) {
        return store.getters.get_ShortMessage_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_ShortMessage_GetPageResult) {
        return store.getters.get_ShortMessage_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_ShortMessage_GetPageResult) {
        return store.getters.get_ShortMessage_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollHeight = window.innerHeight - this.$refs.shortMessageScroll.$el.offsetTop - 320
      window.onresize = () => {
        this.scrollHeight = window.innerHeight - this.$refs.shortMessageScroll.$el.offsetTop - 320
      }
      this.pageIndex = 1
      // this.setPage(1);
      // this.initWebSocket();
      // Cookies.remove('historySimNums')
      this.historySimNums = Cookies.get('historySimNums')
      if (!this.historySimNums) {
        this.historySimNums = []
      } else {
        this.historySimNums = JSON.parse(this.historySimNums)
      }
      if (this.websock === null) {
        this.initWebSocket()
      } else {
        this.websock.close()
        this.websock = null
        this.initWebSocket()
      }
    })
  }
}
</script>

<style scoped>
  .message-history {
    border-radius: 5px;
    border: 2px solid #EEE;
    min-width: 100px;
    margin: auto;
    padding: 10px;
    font-size: 12px;
  }

  .message-time {
    height: 20px;
    line-height: 18px;
  }

  .message-receive .message-time {
    margin-left: 60px;
    text-align: left;
  }

  .message-reply .message-time {
    margin-right: 60px;
    text-align: right;
  }

  .message-info {
    position: relative;
    overflow: hidden;
  }

  .message-content-box {
    border-radius: 5px;
    position: relative;
    padding: 15px;
    word-break: break-word;
  }

  .message-reply .message-content-box {
    background: #b8db29;
    color: #333;
    margin-right: 60px;
    float: right;
  }

  .message-receive .message-content-box {
    background: #CCC;
    color: #333;
    margin-left: 60px;
    float: left;
  }

  .message-content-box .arrow {
    width: 0;
    height: 0;
    font-size: 0;
    border-width: 10px;
    border-style: solid;
    position: absolute;
    top: 10px;
  }

  .message-reply .message-content-box .arrow {
    border-color: transparent transparent transparent #b8db29;
    right: -20px;
  }

  .message-receive .message-content-box .arrow {
    border-color: transparent #CCC transparent transparent;
    left: -20px;
  }

  .item-pics-box {
    float: left;
    margin-right: 10px;
  }

  .item-pic {
    width: 40px;
    height: 40px;
  }

  .message-content {
    overflow: hidden;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 25px;
    position: absolute;
    top: 0;
  }

  .message-receive .user-avatar {
    left: 0;
  }

  .message-reply .user-avatar {
    right: 0;
  }

  .send-message {
    position: relative;
    margin-top: 7px;
    height: 40px;
  }

  .send-message .send-msg-btn {
    float: right;
    width: 75px;
    line-height: 38px;
    height: 38px;
    margin-left: 5px;
    font-size: 14px;
    background-color: #FDFDFD;
    border: 1px solid #D7D7D7;
    text-align: center;
  }

  .send-message .message-input-box {
    border-radius: 3px;

    background-size: 11px 11px;
    background-repeat: no-repeat;
    background-position: 6px 14px;
    padding: 0 0 0 25px;
    background-color: #F9F9F9;
    border: 1px solid #D7D7D7;
    overflow: hidden;
  }

  .send-message input.message-input {
    margin: 0;
    padding: 8px 0;
    font-size: 16px;
    width: 100%;
    height: 100%;
    border: none;
  }

  .demo-split {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    padding: 10px;
  }
</style>
